export default function Logo({ className = "" }) {
  return <img className={className} src="/carelogo-3d.png" alt="logo" />;
}
